export enum FelloOfferJourneyType {
  IO = "IO",
  LWF = "LWF",
  RL = "RL"
}
